// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"blogright_blogContainer__22mN-"};